(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["arvo-confidence"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('arvo-mobile-carousel')) {
  customElements.define('arvo-mobile-carousel', class extends HTMLElement {
    connectedCallback() {
      this.startFrame = requestAnimationFrame(() => this.init());
    }
    init() {
      if (!this.isConnected || this.controller) return;
      this.track = this.querySelector('[data-arvo-track]');
      this.slides = this.track ? Array.from(this.track.children).filter(el => el.hasAttribute('data-arvo-slide')) : [];
      if (!this.track || !this.slides.length) return;
      this.controller = new AbortController();
      const signal = this.controller.signal;
      this.media = matchMedia('(max-width: 749px)');
      this.reducedMotion = matchMedia('(prefers-reduced-motion: reduce)');
      this.nav = this.querySelector('[data-arvo-nav]');
      this.prev = this.querySelector('[data-arvo-prev]');
      this.next = this.querySelector('[data-arvo-next]');
      this.dots = this.querySelector('[data-arvo-dots]');
      this.live = this.querySelector('[data-arvo-live]');
      this.index = 0;
      this.dots.replaceChildren();
      this.dotButtons = this.slides.map((slide, i) => {
        const button = document.createElement('button');
        button.type = 'button';
        button.className = 'arvo-carousel__dot';
        button.setAttribute('aria-label', `Go to slide ${i + 1}`);
        button.setAttribute('aria-controls', this.track.id);
        button.addEventListener('click', () => this.goTo(i), { signal });
        this.dots.append(button);
        return button;
      });
      this.prev.addEventListener('click', () => this.goTo(this.index - 1), { signal });
      this.next.addEventListener('click', () => this.goTo(this.index + 1), { signal });
      this.track.addEventListener('scroll', () => this.scheduleUpdate(), { passive: true, signal });
      this.track.addEventListener('keydown', event => {
        if (!this.active || event.target !== this.track) return;
        const keys = { ArrowLeft: this.index - 1, ArrowRight: this.index + 1, Home: 0, End: this.slides.length - 1 };
        if (Object.prototype.hasOwnProperty.call(keys, event.key)) {
          event.preventDefault();
          this.goTo(keys[event.key]);
        }
      }, { signal });
      this.addEventListener('shopify:block:select', event => {
        const i = this.slides.findIndex(slide => slide === event.target || slide.contains(event.target));
        if (i >= 0 && this.active) this.goTo(i, false);
      }, { signal });
      this.media.addEventListener('change', () => this.setMode(), { signal });
      this.lastWidth = this.track.clientWidth;
      this.observer = new ResizeObserver(() => {
        cancelAnimationFrame(this.resizeFrame);
        this.resizeFrame = requestAnimationFrame(() => {
          if (!this.active || !this.isConnected) return;
          const width = this.track.clientWidth;
          if (width !== this.lastWidth) {
            this.lastWidth = width;
            this.goTo(this.index, false);
          } else {
            this.setHeight();
          }
        });
      });
      this.observer.observe(this.track);
      this.slides.forEach(slide => this.observer.observe(slide));
      this.setMode();
    }
    setMode() {
      this.active = this.dataset.enabled === 'true' && this.media.matches;
      this.dataset.active = String(this.active);
      this.nav.hidden = !this.active || this.slides.length < 2;
      if (this.active) {
        this.setAttribute('role', 'region');
        this.setAttribute('aria-roledescription', 'carousel');
        this.setAttribute('aria-label', this.dataset.label || 'Highlights');
        this.track.setAttribute('tabindex', '0');
        this.track.setAttribute('aria-label', 'Swipe or use the arrow keys to browse');
        this.slides.forEach((slide, i) => {
          slide.setAttribute('role', 'group');
          slide.setAttribute('aria-roledescription', 'slide');
          slide.setAttribute('aria-label', `${i + 1} of ${this.slides.length}`);
        });
        this.goTo(this.index, false);
      } else {
        ['role', 'aria-roledescription', 'aria-label'].forEach(name => this.removeAttribute(name));
        this.track.removeAttribute('tabindex');
        this.track.removeAttribute('aria-label');
        this.track.style.removeProperty('height');
        this.track.scrollTo({ left: 0, behavior: 'instant' });
        this.slides.forEach(slide => {
          slide.inert = false;
          ['role', 'aria-roledescription', 'aria-label', 'aria-hidden'].forEach(name => slide.removeAttribute(name));
        });
      }
    }
    goTo(index, smooth = true) {
      if (!this.active) return;
      const target = Math.max(0, Math.min(index, this.slides.length - 1));
      const delta = this.slides[target].getBoundingClientRect().left - this.track.getBoundingClientRect().left;
      this.track.scrollTo({ left: this.track.scrollLeft + delta, behavior: smooth && !this.reducedMotion.matches ? 'smooth' : 'instant' });
      this.scheduleUpdate();
    }
    scheduleUpdate() {
      cancelAnimationFrame(this.updateFrame);
      this.updateFrame = requestAnimationFrame(() => this.update());
    }
    update() {
      if (!this.active || !this.isConnected) return;
      const left = this.track.getBoundingClientRect().left;
      let nearest = 0;
      let distance = Infinity;
      this.slides.forEach((slide, i) => {
        const d = Math.abs(slide.getBoundingClientRect().left - left);
        if (d < distance) { nearest = i; distance = d; }
      });
      this.index = nearest;
      this.prev.disabled = nearest === 0;
      this.next.disabled = nearest === this.slides.length - 1;
      this.dotButtons.forEach((button, i) => button.setAttribute('aria-current', String(i === nearest)));
      this.slides.forEach((slide, i) => {
        slide.inert = i !== nearest;
        slide.setAttribute('aria-hidden', String(i !== nearest));
      });
      const announcement = `Slide ${nearest + 1} of ${this.slides.length}`;
      if (this.live.textContent !== announcement) this.live.textContent = announcement;
      this.setHeight();
    }
    setHeight() {
      if (!this.active) return;
      const height = Math.ceil(this.slides[this.index].getBoundingClientRect().height) + 2;
      if (this.track.style.height !== `${height}px`) this.track.style.height = `${height}px`;
    }
    disconnectedCallback() {
      cancelAnimationFrame(this.startFrame);
      cancelAnimationFrame(this.resizeFrame);
      cancelAnimationFrame(this.updateFrame);
      if (this.controller) this.controller.abort();
      if (this.observer) this.observer.disconnect();
      this.controller = null;
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["arvo-press-quotes"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('arvo-mobile-carousel')) {
  customElements.define('arvo-mobile-carousel', class extends HTMLElement {
    connectedCallback() {
      this.startFrame = requestAnimationFrame(() => this.init());
    }
    init() {
      if (!this.isConnected || this.controller) return;
      this.track = this.querySelector('[data-arvo-track]');
      this.slides = this.track ? Array.from(this.track.children).filter(el => el.hasAttribute('data-arvo-slide')) : [];
      if (!this.track || !this.slides.length) return;
      this.controller = new AbortController();
      const signal = this.controller.signal;
      this.media = matchMedia('(max-width: 749px)');
      this.reducedMotion = matchMedia('(prefers-reduced-motion: reduce)');
      this.nav = this.querySelector('[data-arvo-nav]');
      this.prev = this.querySelector('[data-arvo-prev]');
      this.next = this.querySelector('[data-arvo-next]');
      this.dots = this.querySelector('[data-arvo-dots]');
      this.live = this.querySelector('[data-arvo-live]');
      this.index = 0;
      this.dots.replaceChildren();
      this.dotButtons = this.slides.map((slide, i) => {
        const button = document.createElement('button');
        button.type = 'button';
        button.className = 'arvo-carousel__dot';
        button.setAttribute('aria-label', `Go to slide ${i + 1}`);
        button.setAttribute('aria-controls', this.track.id);
        button.addEventListener('click', () => this.goTo(i), { signal });
        this.dots.append(button);
        return button;
      });
      this.prev.addEventListener('click', () => this.goTo(this.index - 1), { signal });
      this.next.addEventListener('click', () => this.goTo(this.index + 1), { signal });
      this.track.addEventListener('scroll', () => this.scheduleUpdate(), { passive: true, signal });
      this.track.addEventListener('keydown', event => {
        if (!this.active || event.target !== this.track) return;
        const keys = { ArrowLeft: this.index - 1, ArrowRight: this.index + 1, Home: 0, End: this.slides.length - 1 };
        if (Object.prototype.hasOwnProperty.call(keys, event.key)) {
          event.preventDefault();
          this.goTo(keys[event.key]);
        }
      }, { signal });
      this.addEventListener('shopify:block:select', event => {
        const i = this.slides.findIndex(slide => slide === event.target || slide.contains(event.target));
        if (i >= 0 && this.active) this.goTo(i, false);
      }, { signal });
      this.media.addEventListener('change', () => this.setMode(), { signal });
      this.lastWidth = this.track.clientWidth;
      this.observer = new ResizeObserver(() => {
        cancelAnimationFrame(this.resizeFrame);
        this.resizeFrame = requestAnimationFrame(() => {
          if (!this.active || !this.isConnected) return;
          const width = this.track.clientWidth;
          if (width !== this.lastWidth) {
            this.lastWidth = width;
            this.goTo(this.index, false);
          } else {
            this.setHeight();
          }
        });
      });
      this.observer.observe(this.track);
      this.slides.forEach(slide => this.observer.observe(slide));
      this.setMode();
    }
    setMode() {
      this.active = this.dataset.enabled === 'true' && this.media.matches;
      this.dataset.active = String(this.active);
      this.nav.hidden = !this.active || this.slides.length < 2;
      if (this.active) {
        this.setAttribute('role', 'region');
        this.setAttribute('aria-roledescription', 'carousel');
        this.setAttribute('aria-label', this.dataset.label || 'Highlights');
        this.track.setAttribute('tabindex', '0');
        this.track.setAttribute('aria-label', 'Swipe or use the arrow keys to browse');
        this.slides.forEach((slide, i) => {
          slide.setAttribute('role', 'group');
          slide.setAttribute('aria-roledescription', 'slide');
          slide.setAttribute('aria-label', `${i + 1} of ${this.slides.length}`);
        });
        this.goTo(this.index, false);
      } else {
        ['role', 'aria-roledescription', 'aria-label'].forEach(name => this.removeAttribute(name));
        this.track.removeAttribute('tabindex');
        this.track.removeAttribute('aria-label');
        this.track.style.removeProperty('height');
        this.track.scrollTo({ left: 0, behavior: 'instant' });
        this.slides.forEach(slide => {
          slide.inert = false;
          ['role', 'aria-roledescription', 'aria-label', 'aria-hidden'].forEach(name => slide.removeAttribute(name));
        });
      }
    }
    goTo(index, smooth = true) {
      if (!this.active) return;
      const target = Math.max(0, Math.min(index, this.slides.length - 1));
      const delta = this.slides[target].getBoundingClientRect().left - this.track.getBoundingClientRect().left;
      this.track.scrollTo({ left: this.track.scrollLeft + delta, behavior: smooth && !this.reducedMotion.matches ? 'smooth' : 'instant' });
      this.scheduleUpdate();
    }
    scheduleUpdate() {
      cancelAnimationFrame(this.updateFrame);
      this.updateFrame = requestAnimationFrame(() => this.update());
    }
    update() {
      if (!this.active || !this.isConnected) return;
      const left = this.track.getBoundingClientRect().left;
      let nearest = 0;
      let distance = Infinity;
      this.slides.forEach((slide, i) => {
        const d = Math.abs(slide.getBoundingClientRect().left - left);
        if (d < distance) { nearest = i; distance = d; }
      });
      this.index = nearest;
      this.prev.disabled = nearest === 0;
      this.next.disabled = nearest === this.slides.length - 1;
      this.dotButtons.forEach((button, i) => button.setAttribute('aria-current', String(i === nearest)));
      this.slides.forEach((slide, i) => {
        slide.inert = i !== nearest;
        slide.setAttribute('aria-hidden', String(i !== nearest));
      });
      const announcement = `Slide ${nearest + 1} of ${this.slides.length}`;
      if (this.live.textContent !== announcement) this.live.textContent = announcement;
      this.setHeight();
    }
    setHeight() {
      if (!this.active) return;
      const height = Math.ceil(this.slides[this.index].getBoundingClientRect().height) + 2;
      if (this.track.style.height !== `${height}px`) this.track.style.height = `${height}px`;
    }
    disconnectedCallback() {
      cancelAnimationFrame(this.startFrame);
      cancelAnimationFrame(this.resizeFrame);
      cancelAnimationFrame(this.updateFrame);
      if (this.controller) this.controller.abort();
      if (this.observer) this.observer.disconnect();
      this.controller = null;
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
